<template>
  <div class="container">
    <div class="flex-box">
      <p class="fact-classifi">{{ current_section }} >{{ current_article[0].word }}</p>
      <p class="fact-point">{{ current_section_article_point[current_article[0].id-1].point }}P</p>
    </div>
    <div>
      <h2 class="fact-title">{{ current_article[0].title }}</h2>
      <h3 class="fact-sub">{{ current_article[0].title_sub }}</h3>
    </div>
    <div v-if="session_fwohlist == 'is first article'" class="factcheck">
      <div v-for="(fwohitem, index) in fwohlist" :key="fwohitem.id">
        <div v-if="fwohitem.isquest == false" class="balloon null-balloon">
          <p>{{ fwohitem.key }}</p>
          <p class="balloon-value">{{ fwohitem.value }}</p>
        </div>
        <div v-else>
          <div v-if="factcheck[index] == true" class="balloon correct-balloon">
            <p>{{ fwohitem.key }}</p>
            <p class="balloon-value">{{ fwohitem.value }}</p>
          </div>
          <div v-else-if="factcheck[index] == false" class="balloon fail-balloon">
            <p>{{ fwohitem.key }}</p>
            <p class="balloon-value">{{ fwohitem.value }}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="factcheck">
      <div v-for="(fwohitem, index) in session_fwohlist" :key="fwohitem.id">
        <div v-if="fwohitem.isquest == false" class="balloon null-balloon">
          <p>{{ fwohitem.key }}</p>
          <p class="balloon-value">{{ fwohitem.value }}</p>
        </div>
        <div v-else>
          <div v-if="factcheck[index] == true" class="balloon correct-balloon">
            <p>{{ fwohitem.key }}</p>
            <p class="balloon-value">{{ fwohitem.value }}</p>
          </div>
          <div v-else-if="factcheck[index] == false" class="balloon fail-balloon">
            <p>{{ fwohitem.key }}</p>
            <p class="balloon-value">{{ fwohitem.value }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="desk flex-box">
      <img src="../assets/img/korea_desk.png" />
      <div class="desk-balloon">
        <div v-if="perfectarticle">
          <p>
            완벽합니다!
            <!-- <span>당신의 기사는 팩트 체크를 무사 통과했습니다.</span> -->
          </p>
        </div>
        <div v-else>
          <p>다음 내용이 사실인지 다시 검토해 보세요 :</p>
          <div class="flex-box">
            <div class="deskfor" :key="index" v-for="(factitem, index) in this.factcheck">
              <span v-if="factitem == false">{{ fwohlist[index].key }}</span><span v-if="factitem == false" :class="쉼표 == index ? 'invisible' : ''">,</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- buttons -->
    <button v-if="factcheckactive" class="factcheck-newspaper-active" @click="ispair()">완료하기</button>
    <router-link v-else to="/game/factcheck" class="factcheck-newspaper">완료하기</router-link>
    <router-link
      v-if="!perfectarticle"
      to="/game/5w1h"
      class="factcheck-newspaper-back"
      @click.native.prevent="loadfwohlist"
    >다시하기</router-link>
    <!-- getpointmodal -->
    <div v-show="showgetpointmodal" class="getpoint-mask">
      <div class="getpoint-wrapper">
        <div class="getpoint-container">
          <div class="getpoint-header flex-box">
            <img src="../assets/img/good_title.png" />
            <!-- <div class="left-feather"></div>
            <h2 v-if="perfectarticle">
              A PERFECT ARTICLE
              <span>{{ getpoint }}P</span>
            </h2>
            <h2 v-else>
              A GOOD ARTICLE
              <span>{{ getpoint }}P</span>
            </h2>
            <div class="right-feather"></div> -->
            <h2>
            <span>{{ getpoint }}P</span>
            </h2>
          </div>
          <div class="getpoint-body flex-box">
            <p>완성한 기사에 대한 나의 감정 태그를 골라주세요.</p>
          </div>
          <div>
            <div class="tag-control">
              <label class="tagradio">
                <input type="radio" name="radio" value="happy" v-model="hashtag" />
                <p>#감동적인</p>
              </label>
              <label class="tagradio">
                <input type="radio" name="radio" value="hope" v-model="hashtag" />
                <p>#흥미로운</p>
              </label>
              <label class="tagradio">
                <input
                  type="radio"
                  name="radio"
                  value="indifference"
                  checked="checked"
                  v-model="hashtag"
                />
                <p>#안타까움</p>
              </label>
              <label class="tagradio">
                <input type="radio" name="radio" value="sad" v-model="hashtag" />
                <p>#답답함</p>
              </label>
              <label class="tagradio">
                <input type="radio" name="radio" value="frustration" v-model="hashtag" />
                <p>#기타</p>
              </label>
            </div>
          </div>
          <button v-if="ispairarticle" class="getpoint-button" @click="pointtopair">완료하기</button>
          <router-link
            v-else-if="perfectarticle"
            to="/game/newspaper/1"
            class="getpoint-button"
            @click.native.prevent="updatehashtag"
          >완료</router-link>
          <router-link
            v-else
            to="/game/newspaper/2"
            class="getpoint-button"
            @click.native.prevent="updatehashtag"
          >완료</router-link>
        </div>
      </div>
    </div>
    <!-- pairarticlemodal -->
    <div v-show="showpairmodal" class="pair-mask">
      <div class="pair-wrapper">
        <div :class="paircolor" class="pair-container">
          <div :class="paircolor" class="pair-header">
            <img src="../assets/img/paired_title.png" />
          </div>
          <div class="pair-body">
            <div class="pair1">
              <p :class="paircolor" class="pairboxpoint">{{pair1point}}P</p>
              <div class="pairboxstar"></div>
              <p :class="paircolor" class="pairboxtitle">{{pair1title}}</p>
            </div>
            <div class="link"></div>
            <div class="pair2">
              <p :class="paircolor" class="pairboxpoint">{{pair2point}}P</p>
              <div class="pairboxstar"></div>
              <p :class="paircolor" class="pairboxtitle">{{pair2title}}</p>
            </div>
            <div v-if="pair3point > 0" class="link"></div>
            <div v-if="pair3point > 0"  class="pair2">
              <p :class="paircolor" class="pairboxpoint">{{pair3point}}P</p>
              <div class="pairboxstar"></div>
              <p :class="paircolor" class="pairboxtitle">{{pair3title}}</p>
            </div>
          </div>
          <div class="pair-footer">
            <h2>+{{pairpoint}}P</h2>
            <p>{{ pairtext }}</p>
          </div>
          <router-link v-if="perfectarticle" to="/game/newspaper/1" class="pair-button">확인</router-link>
          <router-link v-else to="/game/newspaper/2" class="pair-button">확인</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
/* eslint-disable */
export default {
  data() {
    return {
      showgetpointmodal: false,
      showpairmodal: false,
      ispairarticle: false,
      //getpointmodal 헤더 글씨를 위한 상태변수
      factcheckactive: false,
      perfectarticle: false,
      /* ******************************* */
      getpoint: 0,
      hashtag: "indifference",
      pairpoint: 600,
      pairtext:
        "장벽을 넘어 서독을 방문한 호네커와 군사 분계선을 넘어 남한을 방문한 김정은",
      pair1point: 300,
      pair1title: "장벽을 넘어",
      pair2point: 300,
      pair2title: "김정은",
      pair3point: 0,
      pair3title: "하나",
      paircolor: "",
    };
  },
  computed: {
    ...mapGetters([
      "session_article",
      "session_section",
      "current_section",
      "current_article",
      "current_section_article_point",
      "current_article_id",
      "current_article_fwoh",
      "current_articleLink",
      "session_fwohlist",
      "session_checklist",
      "factcheck",
      "fwohlist",
    ]),
    쉼표() {
      let max_index = 1;
      let end_index = this.factcheck.reduce((acc, cur, idx) => {
        if (idx == 1) {
          if (cur == false) {
            max_index = idx;
          } else if (acc == false) {
            max_index = idx-1;
          }
          return false
        }
        else if( cur == false){
          max_index = idx
          return false
        }
      });
      return max_index
    },
  },
  created() {
    this.ispairarticle = false;
  },
  updated() {
    this.issendable();
  },
  methods: {
    ispair() {
      this.getPoint();
      this.showgetpointmodal = true;
      var vm = this;
      axios
        .get(
          `http://dokdo.nolple.com:8000/session/ispair/${this.session_section}/${this.session_article}`,
          {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
          }
        )
        .then(function (response) {
          if (response.data.result == true) {
            vm.ispairarticle = true;
            vm.pair1point = response.data.pairpoint;
            vm.pair1title = response.data.pairword;
            vm.pair2title = vm.current_article[0].word;
            vm.paircolor = vm.current_articleLink.color;
            vm.pairtext = vm.current_articleLink.desc;
            vm.pairpoint = vm.pair2point + vm.pair1point;
          }
          else if (response.data.result == 'many')  {
            vm.ispairarticle = true;
            vm.pair3point = vm.pair2point
            vm.pair1point = response.data.pairpoint[0];
            vm.pair1title = response.data.pairword[0];
            vm.pair2point = response.data.pairpoint[1];
            vm.pair2title = response.data.pairword[1];
            vm.pair3title = vm.current_article[0].word;
            vm.paircolor = vm.current_articleLink.color;
            vm.pairtext = vm.current_articleLink.desc;
            vm.pairpoint = vm.pair2point + vm.pair1point + vm.pair3point;
          }
          else {
            vm.ispairarticle = false;
          }
        })
        .catch(function (error) {
          alert("에러! API 요청에 오류가 있습니다. " + error);
        });
    },
    pointtopair() {
      //point modal에서 pair modal로 스위치하는 메소드
      this.$store.dispatch("sendhashtag", this.hashtag);
      this.$store.dispatch("sendPointdouble", this.getpoint);
      this.showgetpointmodal = !this.showgetpointmodal;
      this.showpairmodal = !this.showpairmodal;
    },
    updatehashtag() {
      this.$store.dispatch("sendhashtag", this.hashtag);
      this.$store.dispatch("sendPoint", this.getpoint);
      this.showgetpointmodal = !this.showgetpointmodal;
      this.$store.dispatch("loadhashtag", this.current_article_id);
    },
    issendable() {
      const foundtrue = this.factcheck.find(function (element) {
        return element == true;
      });
      const foundfalse = this.factcheck.find(function (element) {
        return element == false;
      });
      if (foundtrue == undefined) {
        this.factcheckactive = false;
        this.perfectarticle = false;
      } else if (foundfalse == undefined) {
        this.factcheckactive = true;
        this.perfectarticle = true;
      } else {
        this.factcheckactive = true;
        this.perfectarticle = false;
      }
    },
    getPoint() {
      var pointarray = [];
      var here = this;
      here.factcheck.forEach(function (element, index) {
        if (element == true) {
          pointarray.push(here.fwohlist[index].point);
        }
      });
      const reducer = (accumulator, currentValue) => accumulator + currentValue;
      this.getpoint = pointarray.reduce(reducer);
      this.pair2point = this.getpoint;
    },
    loadfwohlist() {
      this.$store.dispatch("loadfwohlist", this.current_article_id);
    },
  },
};
</script>

<style>
@font-face {
  font-family: "american_typewriter";
  src: url(../assets/fonts/american_typewriter_bold.ttf) format("truetype");
}

/* getpointmodal */
.getpoint-mask {
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.getpoint-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.getpoint-container {
  width: 270px;
  margin: 0px auto;
  padding: 20px 23px;
  border: black solid 2px;
  background-color: yellow;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.getpoint-container p {
  padding: 5%;
}
.getpoint-button {
  display: block;
  background-color: yellow;
  color: black;
  border: black 1px solid;
  text-align: center;
  font-size: 1em;
  width: 100%;
  margin-top: 1em;
  padding: 2%;
}
.getpoint-header {
  /* background-image: url("../assets/img/point-leaves.png");
  background-position: center;
  background-size: contain; */
  /* height: 87px; */
  /* margin-bottom: 27px; */
  flex-direction: column;
}
.getpoint-header h2 {
  margin-top: -20px;
  font-family: "american_typewriter", Courier, monospace;
  text-align: center;
  font-size: larger;
  font-weight: bold;
  color: black;
}
.getpoint-header h2 > span {
  font-family: "american_typewriter", Courier, monospace;
  text-align: center;
  font-size: xx-large;
  font-weight: bold;
  color: black;
}
.right-feather {
  /* background-image: url('../assets/img/right_feather.png'); */
  background-size: contain;
  width: 83px;
  height: 92px;
}
.left-feather {
  /* background-image: url('../assets/img/left_feather.png'); */
  background-size: contain;
  width: 82px;
  height: 92px;
}
.get-point {
  font-family: "american_typewriter", Courier, monospace;
  text-align: center;
  font-size: xx-large;
  font-weight: bold;
}
.getpoint-body {
  text-align: center;
}

.tagradio p {
  border: black 1px solid;
  border-radius: 8pt;
  background-color: rgb(216, 216, 216);
  color: black;
  padding: 2% 1%;
  margin: 1% 0;
  display: -webkit-inline-box;
}
.tagradio > input {
  display: none;
}
.tagradio > input[type="radio"]:checked + p {
  background-color: black;
  color: white;
}
.tag-control {
  box-sizing: border-box;
  clear: both;
  font-size: 1rem;
  position: relative;
  text-align: center;
}
/********************/

/* pairarticlemodal */
.pair-mask {
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.pair-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.pair-container {
  width: 344px;
  margin: 0px auto;
  padding: 20px 23px;
  border: black solid 2px;
  background-color: #ff8c00;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.pair-body {
  color: #ff8c00;
}
.pair-container.BLUE {
  background-color: #1565c2;
}
.BLUE.pair-body {
  color: #1565c2;
}
.pair-container.RED {
  background-color: #d0021b;
}
.RED.pair-body {
  color: #d0021b;
}
.pair-container.GREEN {
  background-color: #417505;
}
.GREEN.pair-body {
  color: #417505;
}
.pair-container p {
  padding: 1%;
  text-align: center;
  color: black;
}
.pair-button {
  display: block;
  background-color: black;
  color: white;
  text-align: center;
  font-size: 1.5em;
  margin: 5%;
  width: 90%;
  border: black 2px solid;
  padding: 2%;
}
.pair-container h2 {
  font-family: "american_typewriter", Courier, monospace;
  text-align: center;
  font-size: xx-large;
  font-weight: bold;
  color: black;
}
.pair-header {
  margin-bottom: 2%;
}
.pair-header img{
  margin: 0 auto;
}
.pair-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.pair-body .link {
  width: 30px;
  height: 10px;
  border: black 5px solid;
}
.pair1,
.pair2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border: black 5px solid;
  background: white;
  font-weight: bold;
}
.pair-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 5%;
}
.pairboxpoint {
  font-size: larger;
  border: none !important;
}
.pairboxpoint.BLUE {
  font-size: larger;
  color: #1565c2;
}
.pairboxpoint.RED {
  font-size: larger;
  color: #d0021b;
}
.pairboxpoint.GREEN {
  font-size: larger;
  color: #417505;
}
.pairboxtitle {
  font-size: x-small;
  border: none !important;
}
.pairboxtitle.BLUE {
  font-size: x-small;
  color: #1565c2;
}
.pairboxtitle.RED {
  font-size: x-small;
  color: #d0021b;
}
.pairboxtitle.GREEN {
  font-size: x-small;
  color: #417505;
}
.pairboxstar {
  background-image: url(../assets/img/top_star.png);
  background-size: contain;
  width: 24px;
  height: 24px;
}
/********************/
</style>


// WEBPACK FOOTER //
// src/components/factcheck.vue